import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import BukkuTooltip from '../Tooltip';
import { Styled } from './style';
import { CommonUrl } from '../Access/helper/utils/CommonUrl';
import { PermissionSubscriptionCheck } from '../Access/helper/PermissionSubscriptionCheck';
import OpenInNewIcon from "../IconFont/OpenInNewIcon";

function LinkTo({ to, target, children, allowed }) {
    if (!allowed)
        return children;

    return (
        <span>
            <Link to={to} target={target}>
                {children}
            </Link>
        </span>
    );
}

/**
 * @property {number} contactId - required.
 * @property {string} label - required.
 * @property {{icon:ReactDOM, title: string}} [extra] - optional.
 *          will be placed after the label text and before the
 *              <SelectOutlined /> link icon, title key to support tooltip
 */
export class ContactLink extends Component {
    static propTypes = {
        contactId: PropTypes.number.isRequired,
        contactCode: PropTypes.string,
        label: PropTypes.string.isRequired,
        // newWindow: PropTypes.bool,
        // eslint-disable-next-line react/forbid-prop-types
        extra: PropTypes.object,
    };

    getTooltipText = () => {
        const { extra, label, contactCode } = this.props;
        return (
            <>
                <div>
                    {label}
                    &nbsp;
                    {extra ? extra.icon : undefined}
                </div>

                {
                    contactCode && (
                        <div>
                            <span className="bolded-gray monospace">
                                {contactCode}
                            </span>
                        </div>
                    )
                }
            </>
        );
    };

    renderExtraIcon = () => {
        const {
            extra,
        } = this.props;
        if (extra) {
            return (
                <BukkuTooltip title={extra.title}>
                    <span>
                        &nbsp;
                        {extra.icon}
                    </span>
                </BukkuTooltip>
            );
        }
        return null;
    };

    renderLinkifyIcon = linkifyAllowed => {
        if (linkifyAllowed)
            return <OpenInNewIcon />;

        return null;
    };

    render() {
        const {
            label,
            contactId,
        } = this.props;

        // Check permission if matched
        const { allowed } = PermissionSubscriptionCheck.withUrl(CommonUrl.contacts).hasPermissionTo();
        const linkifyAllowed = allowed && contactId;

        return (
            <Styled>
                <span
                    className="span__label-icon-group ellipsis-div"
                    onClick={e => {
                        e.stopPropagation();
                    }}
                >
                    <LinkTo allowed={linkifyAllowed} to={`/contacts/${contactId}`}>
                        <BukkuTooltip
                            title={this.getTooltipText()}
                            placement="topLeft"
                            // autoAdjustOverflow="false"
                        >
                            <span style={{ fontSize: "inherit" }}>
                                {label || null}
                            </span>
                        </BukkuTooltip>
                        {this.renderExtraIcon()}
                    </LinkTo>
                </span>
                <span
                    onClick={e => {
                        e.stopPropagation();
                    }}
                >
                    <LinkTo allowed={linkifyAllowed} to={`/contacts/${contactId}`} target="_blank">
                        {this.renderLinkifyIcon(linkifyAllowed)}
                    </LinkTo>
                </span>
            </Styled>
        );
    }
}
